import type { WidgetsIconMap } from '@mwl/core-lib';

import GraphIcon from '@public/assets/sport/icons/graph.svg';
import MatchIcon from '@public/assets/sport/icons/match.svg';
import PlayIcon from '@public/assets/sport/icons/play.svg';
import StatsIcon from '@public/assets/sport/icons/stats.svg';

export const widgetsIcons: WidgetsIconMap = {
  broadcast: PlayIcon,
  stats: StatsIcon,
  graph: GraphIcon,
  match: MatchIcon,
};
